import { Box, Heading, Text } from "src/components/UI";

const DirectDebitHeader = () => {
  return (
    <Box
      width="100%"
      padding={["16px", "16px"]}
      alignItems={["flex-start", "flex-start"]}
      gap={["8px", "16px"]}
    >
      <Heading
        as="h1"
        fontFamily="Roboto, sans-serif"
        fontSize={["17px", "34px"]}
        fontWeight={["700", "700"]}
        lineHeight={["24px", "48px"]}
        letterSpacing={["0px", "-0.32px"]}
        textAlign={["left", "left"]}
        color={["#404040"]}
      >
        Praktis Dengan Fitur Bayar Otomatis
      </Heading>
      <Text
        fontFamily="Roboto, sans-serif"
        fontSize={["13px", "16px"]}
        fontWeight={["500", "400"]}
        lineHeight={["20px", "24px"]}
        letterSpacing={["0.24px", "0px"]}
        textAlign={["left", "left"]}
        color={["#676767", "#666666"]}
      >
        Bayar Otomatis bikin kamu anti telat bayar cicilan. Dengan fitur ini,
        saldo rekeningmu di bank akan terpotong secara otomatis setiap bulan
        sehingga tagihan Home Credit kamu jadi bisa terbayar sesuai jadwal.
      </Text>
    </Box>
  );
};

export default DirectDebitHeader;
